import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/next/font/local/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"../../public/fonts/InterVariable.woff2\",\"display\":\"swap\",\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleAnalytics"] */ "/app/apps/web/src/lib/analytics/google-analytics.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/styles/globals.css");
